import LoginLayout from "../../shared/oversight-core/shared-components/login-layout/login-layout";
import AdminLoginForm from "./login-form/login-form";

const AdminLogin = () => {
  return (
    <LoginLayout title="Log in to Your Account">
      <AdminLoginForm />
    </LoginLayout>
  );
};

export default AdminLogin;
